/* FTP Endurance Fuel — fuel planner v2.
   Goal-first: what you're training for, target time, race date or plan length, how you like to fuel.
   Gives a race-day plan (per leg for triathlon), this week's long-session plan, the total for the whole
   training block, and a basket sized to that total. "Email me my plan" saves the race to the Klaviyo profile
   so the race countdown flows can run from the race date.
   Guidance bands follow current sports-nutrition consensus (under 1h little or nothing, 1–2.5h 30–60g/h,
   beyond 2.5h 60–90g/h; running a little lower than riding; build up in training). */
(function () {
  if (window.__ftpPlanner2) return;
  window.__ftpPlanner2 = true;

  var CARB_PER_SCOOP = 27, NA_PER_SCOOP = 300, CARB_PER_CHEW = 15, NA_PER_TAB = 300;
  var CHEWS_PER_KG = 60, SCOOPS_PER_PF = 30, CHEWS_PER_TASTER = 4;

  // [label, race hours, race carbs per hour]
  var EVENTS = {
    run10k:   { label: '5k or 10k', sport: 'run', race: true, times: [['Under 40 min', 0.6, 0], ['40 to 50 min', 0.75, 0], ['50 to 60 min', 0.9, 30], ['Over an hour', 1.2, 30]], peak: function (L0, h) { return Math.max(L0, 1.25); } },
    half:     { label: 'Half marathon', sport: 'run', race: true, times: [['Under 1:30', 1.4, 60], ['1:30 to 1:50', 1.7, 50], ['1:50 to 2:15', 2.0, 45], ['Over 2:15', 2.5, 45]], peak: function () { return 2.0; } },
    marathon: { label: 'Marathon', sport: 'run', race: true, times: [['Under 3:00', 2.85, 80], ['3:00 to 3:30', 3.25, 75], ['3:30 to 4:00', 3.75, 70], ['4:00 to 4:30', 4.25, 65], ['4:30 to 5:00', 4.75, 60], ['Over 5:00', 5.5, 55]], peak: function (L0, h) { return Math.min(3, h * 0.85); }, taper: 3 },
    ultra:    { label: 'Ultra or trail', sport: 'run', race: true, times: [['Under 5 hours', 4.5, 65], ['5 to 8 hours', 6.5, 60], ['8 to 12 hours', 10, 60], ['Over 12 hours', 15, 55]], peak: function (L0, h) { return Math.min(5, h * 0.55); }, taper: 3 },
    sportive: { label: 'Sportive or big ride', sport: 'ride', race: true, times: [['Under 4 hours', 3.5, 75], ['4 to 6 hours', 5, 80], ['6 to 8 hours', 7, 80], ['Over 8 hours', 9, 75]], peak: function (L0, h) { return Math.min(6, h * 0.8); } },
    tri_short:{ label: 'Sprint or Olympic triathlon', sport: 'tri', race: true, legs: [0.17, 0.5, 0.33], times: [['Under 2:15', 2.0, 60], ['2:15 to 2:45', 2.5, 60], ['Over 2:45', 3.0, 55]], peak: function () { return 2.0; } },
    tri_half: { label: '70.3 / middle distance', sport: 'tri', race: true, legs: [0.11, 0.52, 0.37], times: [['Under 5 hours', 4.6, 80], ['5 to 6 hours', 5.5, 80], ['6 to 7 hours', 6.5, 75], ['Over 7 hours', 7.5, 70]], peak: function () { return 4; }, taper: 3 },
    tri_full: { label: 'Ironman / full distance', sport: 'tri', race: true, legs: [0.1, 0.52, 0.38], times: [['Under 10 hours', 9.5, 90], ['10 to 12 hours', 11, 85], ['12 to 14 hours', 13, 80], ['Over 14 hours', 15, 75]], peak: function () { return 6; }, taper: 3 },
    ride:     { label: 'Cycling, no event', sport: 'ride', race: false, timesLabel: 'Your longest ride', times: [['1 to 2 hours', 1.5, 50], ['2 to 3 hours', 2.5, 65], ['3 to 5 hours', 4, 75], ['5 hours plus', 6, 80]], peak: function (L0, h) { return h; } },
    training: { label: 'Running, no event', sport: 'run', race: false, timesLabel: 'Your longest run', times: [['1 to 1:30', 1.25, 30], ['1:30 to 2:30', 2, 45], ['2:30 plus', 3, 60]], peak: function (L0, h) { return h; } }
  };
  var LONGEST = { a: 0.75, b: 1.25, c: 1.75, d: 2.5, e: 3.5 };
  var SWEAT = { light: [300, 400], average: [500, 550], heavy: [800, 750] };
  var COND = { cool: [0.8, 0.8], mild: [1, 1], hot: [1.25, 1.3] };

  function r5(x) { return Math.round(x / 5) * 5; }
  function r50(x) { return Math.round(x / 50) * 50; }
  function fmtH(h) { var hh = Math.floor(h), mm = Math.round((h - hh) * 60); if (mm === 60) { hh++; mm = 0; } return hh ? hh + 'h' + (mm ? ' ' + (mm < 10 ? '0' : '') + mm : '') : mm + ' min'; }
  function plural(n, w, p) { return n + ' ' + (n === 1 ? w : (p || w + 's')); }
  function slugify(s) { return String(s || '').toLowerCase().replace(/&/g, 'and').replace(/\b(19|20)\d\d\b/g, ' ').replace(/\b(the|my|race|event)\b/g, ' ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60); }

  /* Race name matching: "manchestrr", "manc marathon" and "Manchester Marathon 2027" all resolve to the same
     approved race. Approved races come from the shop metafield ftp.race_index (kept up to date by the brief task). */
  var RSTOP = { the: 1, my: 1, race: 1, event: 1, a: 1, of: 1, 'in': 1 };
  var RALIAS = { manc: 'manchester', mcr: 'manchester', manny: 'manchester', ldn: 'london', vlm: 'london', tcs: '', adidas: '', asics: '',
    gnr: 'great north run', gsr: 'great scottish run', brum: 'birmingham', bham: 'birmingham', edi: 'edinburgh', edin: 'edinburgh',
    abz: 'aberdeen', glasgae: 'glasgow', notts: 'nottingham', mara: 'marathon', marathn: 'marathon', marthon: 'marathon',
    hm: 'half marathon', half: 'half', im: 'ironman', mdot: 'ironman', ult: 'ultra', '10km': '10k', sportiv: 'sportive' };
  function rtokens(s) {
    var out = [];
    String(s || '').toLowerCase().replace(/&/g, ' and ').replace(/\b(19|20)\d\d\b/g, ' ').replace(/[^a-z0-9.]+/g, ' ').trim().split(/\s+/).forEach(function (t) {
      if (!t || RSTOP[t]) return;
      var a = Object.prototype.hasOwnProperty.call(RALIAS, t) ? RALIAS[t] : t;
      if (a) a.split(' ').forEach(function (x) { out.push(x); });
    });
    return out;
  }
  function lev(a, b) {
    if (a === b) return 0; if (Math.abs(a.length - b.length) > 2) return 3;
    var p = [], i, j; for (j = 0; j <= b.length; j++) p[j] = j;
    for (i = 1; i <= a.length; i++) { var c = [i]; for (j = 1; j <= b.length; j++) c[j] = Math.min(p[j] + 1, c[j - 1] + 1, p[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1)); p = c; }
    return p[b.length];
  }
  function tokScore(q, t) {
    if (q === t) return 1;
    if (q.length >= 3 && t.indexOf(q) === 0) return 0.95;
    var d = lev(q, t), allow = q.length <= 4 ? 1 : 2;
    return d <= allow ? 1 - d * 0.2 : 0;
  }
  function raceScore(qt, names) {
    var best = 0;
    names.forEach(function (n) {
      var et = rtokens(n); if (!et.length || !qt.length) return;
      var sum = 0, used = {};
      for (var i = 0; i < qt.length; i++) {
        var bs = 0, bj = -1;
        for (var j = 0; j < et.length; j++) { var sc = tokScore(qt[i], et[j]); if (sc > bs) { bs = sc; bj = j; } }
        if (!bs) return; // every word typed must match something
        used[bj] = 1; sum += bs;
      }
      var cover = Object.keys(used).length / et.length;
      var sc = (sum / qt.length) * (0.6 + 0.4 * cover);
      if (sc > best) best = sc;
    });
    return best;
  }
  function matchRaces(q, list, evKey) {
    var qt = rtokens(q); if (!qt.length || q.trim().length < 2) return [];
    return list.map(function (r) {
      var sc = raceScore(qt, [r.name].concat(r.aliases || []).map(function (a) { return String(a).replace(/-/g, ' '); }));
      if (sc && evKey && r.event_type) sc += r.event_type === evKey ? 0.1 : -0.15; // the event type already chosen breaks ties
      return { r: r, s: sc };
    })
      .filter(function (m) { return m.s >= 0.55; }).sort(function (a, b) { return b.s - a.s; }).slice(0, 5);
  }
  function fmtRaceDate(d) { var x = new Date(d + 'T12:00:00'); return isNaN(x) ? '' : x.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }); }

  // Delivery for one leg: hours h, carbs per hour c
  function leg(h, c, sport, inp, fluid) {
    var bottles = { pockets: 0, one: 1, two: 2 }[inp.carry]; if (bottles === undefined) bottles = 1;
    var maxPH = fluid >= 400 ? Math.max(1, Math.floor(fluid / 300)) : 0;
    var scoopsPH = 0;
    if (c > 0 && bottles > 0 && inp.pref !== 'chew') {
      var want = inp.pref === 'drink' ? Math.min(maxPH, Math.floor((c + 5) / CARB_PER_SCOOP)) : Math.min(1, maxPH);
      if (inp.pref === 'mix' && h < 1.5 && sport !== 'ride') want = 0; // short run: water in the bottle, pastilles for carbs
      if (!inp.refill) want = Math.min(want, (bottles * (sport === 'run' ? 1 : 2)) / Math.max(h, 1));
      scoopsPH = Math.max(0, want);
    }
    var totalScoops = Math.round(scoopsPH * h * 2) / 2; // half scoops allowed in a bottle
    var totalCarbs = c * h;
    var totalChews = Math.max(0, Math.ceil((totalCarbs - totalScoops * CARB_PER_SCOOP) / CARB_PER_CHEW - 0.25));
    var chewsPH = totalChews / Math.max(h, 0.01);
    return { hours: h, carbs: c, scoops: totalScoops, scoopsPH: scoopsPH, chews: totalChews, chewsPH: chewsPH,
      every: totalChews ? (60 * h / totalChews < 15 ? Math.round(60 * h / totalChews) : r5(60 * h / totalChews)) : 0, bottles: bottles };
  }

  function plan(inp) {
    var ev = EVENTS[inp.event] || EVENTS.marathon;
    var t = ev.times[Math.min(inp.time | 0, ev.times.length - 1)];
    var raceH = t[1], target = t[2];
    var sw = SWEAT[inp.sweat] || SWEAT.average, cd = COND[inp.cond] || COND.mild;
    var runF = ev.sport === 'run' ? 0.85 : 1;
    var sodium = r50(sw[0] * cd[0]);
    var fluid = Math.min(ev.sport === 'run' ? 800 : 1000, r50(sw[1] * cd[1] * runF));

    // Race day legs
    var legs = [];
    if (ev.sport === 'tri') {
      var bikeC = Math.min(90, target + 10), runC = Math.max(30, target - 15);
      legs.push({ name: 'Swim', d: leg(raceH * ev.legs[0], 0, 'swim', inp, fluid) });
      legs.push({ name: 'Bike', d: leg(raceH * ev.legs[1], bikeC, 'ride', inp, fluid) });
      legs.push({ name: 'Run', d: leg(raceH * ev.legs[2], runC, 'run', Object.assign({}, inp, { carry: inp.carry === 'two' ? 'one' : inp.carry }), Math.round(fluid * 0.85)) });
    } else {
      legs.push({ name: ev.sport === 'ride' ? 'Ride' : 'Run', d: leg(raceH, target, ev.sport, inp, fluid) });
    }
    var raceChews = 0, raceScoops = 0, raceCarbs = 0;
    legs.forEach(function (l) { raceChews += l.d.chews; raceScoops += l.d.scoops; raceCarbs += l.d.carbs * l.d.hours; });
    var chewShare = raceCarbs ? (raceChews * CARB_PER_CHEW) / (raceChews * CARB_PER_CHEW + raceScoops * CARB_PER_SCOOP) : 1;
    if (!isFinite(chewShare)) chewShare = 1;
    var avgCarbs = raceCarbs ? r5(raceCarbs / raceH) : 0;

    // Sodium top-up with tablets
    var scoopNaPH = (raceScoops / raceH) * NA_PER_SCOOP;
    var naLeft = sodium - scoopNaPH;
    var tabsPH = (raceH >= 1.5 || inp.sweat === 'heavy') ? (naLeft >= 450 ? 2 : naLeft >= 250 ? 1 : 0) : 0;

    // Weeks to go
    var days = null, weeks = Number(inp.weeks) || 12;
    if (inp.date) {
      var d = new Date(inp.date + 'T09:00:00');
      if (!isNaN(d)) { days = Math.round((d - new Date()) / 864e5); weeks = Math.max(0, Math.floor(days / 7)); }
    }
    weeks = Math.min(weeks, 30);
    if (!ev.race) weeks = 6;

    // Training block: long session ramps from where you are now to the peak, then tapers
    var L0 = ev.race ? (LONGEST[inp.longest] || 1.25) : raceH;
    var peak = Math.max(L0, ev.peak(L0, raceH));
    var taper = ev.taper || 2;
    var peakWeek = Math.max(1, weeks - taper);
    var startRate = ev.race ? Math.min(target || 30, (inp.newbie || L0 < 1.5) ? 30 : 40) : target;
    var minFuel = ev.sport === 'ride' ? 1.5 : 1.25;
    var blockCarbs = 0, thisWeek = null, extra = Math.max(0, (Number(inp.sessions) || 1) - 1);
    for (var w = 1; w < (ev.race ? weeks : weeks + 1); w++) {
      var frac = peakWeek > 1 ? Math.min(1, (w - 1) / (peakWeek - 1)) : 1;
      var L = w <= peakWeek ? L0 + (peak - L0) * frac : peak * 0.6;
      var rate = startRate + (Math.max(target, startRate) - startRate) * frac;
      var g = L >= minFuel ? L * rate : 0;
      if (w === 1) thisWeek = { hours: L, rate: r5(rate), chews: Math.ceil(g * chewShare / CARB_PER_CHEW), scoops: Math.round(g * (1 - chewShare) / CARB_PER_SCOOP * 2) / 2, fuelled: g > 0 };
      blockCarbs += g + (inp.event !== 'run10k' && (w > 1 || !ev.race) ? extra * 1.25 * 30 : 0);
    }
    if (ev.race) blockCarbs += raceCarbs;
    if (!thisWeek) thisWeek = { hours: L0, rate: r5(startRate), chews: Math.ceil(L0 * startRate * chewShare / CARB_PER_CHEW), scoops: 0, fuelled: L0 >= minFuel };
    var blockChews = Math.ceil(blockCarbs * chewShare / CARB_PER_CHEW);
    var blockScoops = Math.ceil(blockCarbs * (1 - chewShare) / CARB_PER_SCOOP);

    return {
      ev: ev, evKey: inp.event, timeLabel: t[0], raceH: raceH, target: target, avgCarbs: avgCarbs, sodium: sodium, fluid: fluid,
      legs: legs, raceChews: raceChews, raceScoops: raceScoops, tabsPH: tabsPH, days: days, weeks: weeks,
      L0: L0, peak: peak, thisWeek: thisWeek, blockCarbs: Math.round(blockCarbs), blockChews: blockChews, blockScoops: blockScoops,
      chewShare: chewShare, salty: inp.sweat === 'heavy' || inp.cond === 'hot'
    };
  }
  window.ftpFuelPlan2 = plan;

  // Basket sized to the block
  function basket(inp, p, recs) {
    var P = p.blockChews, S = p.blockScoops, flav = inp.flavour;
    var tc = flav === 'tc';
    function k(a, b) { return recs[a] ? a : b; }
    var sized, note = '';
    var boxes = Math.max(P / CHEWS_PER_KG, S / SCOOPS_PER_PF);
    var longEvent = ['half', 'marathon', 'ultra', 'sportive', 'tri_half', 'tri_full'].indexOf(inp.event) > -1;
    // 3 Oct 2026: size by pastilles needed. 1 taster = 4 pastilles; 3 packs = 12; 5 packs = 20; above that a kilo is better value.
    if (P <= 4 && S <= 2) sized = tc ? k('tasters_tc', 'tasters') : 'tasters';
    else if (P <= 12 && S <= 2) sized = tc ? k('tasters3_tc', 'tasters3') : 'tasters3';
    else if (P <= 20 && S <= 2) sized = tc ? k('tasters5_tc', 'tasters5') : 'tasters5';
    else if (S <= 2) {
      if (P <= 70) sized = flav === 'both' ? 'rotation' : (tc ? k('pastilles_tc', 'pastilles') : 'pastilles');
      else sized = 'rotation';
      if (P > 140) note = 'Your plan gets through about ' + Math.round(P / CHEWS_PER_KG * 10) / 10 + 'kg of pastilles, so expect to reorder once.';
    } else if (P <= 4) sized = inp.caffeine === 'yes' ? k('fluids_core', 'fluids') : 'fluids';
    else if (P <= 20 && S <= 10) sized = 'long'; // 4 tasters + 4 Power Fluids sachets + bottle + pouch: about 8 fuelled sessions
    else if (P <= 20) sized = inp.caffeine === 'yes' ? k('fluids_core', 'fluids') : 'fluids';
    else if (longEvent && (p.days !== null ? (p.days >= 0 && p.days <= 28) : p.weeks <= 4) && !inp.newbie) sized = tc ? k('raceweek_tc', 'raceweek') : 'raceweek';
    else {
      sized = 'system';
      if (p.weeks >= 8 && boxes > 1.2) note = 'Your plan uses about ' + Math.round(boxes * 10) / 10 + ' boxes. A reload ships every 6 weeks. Skip any you won\'t need from your account.';
      else if (!p.ev.race && boxes <= 1.4) note = boxes >= 0.75 ? 'That\'s about one box every 6 weeks, which is how often the System ships.' : 'One box lasts you about ' + Math.round(6 / Math.max(boxes, 0.2)) + ' weeks at this rate, so skip a reload when you need to.';
      else if (boxes <= 1.2) note = 'One box covers your plan. Cancel after the first if that\'s all you need.';
    }
    var primary = sized, then = null;
    // 3 Oct 2026: anyone who hasn't tried FTP starts with the Starter Stack (both flavours + Power Fluids taster + pouch),
    // then the kit sized to their plan. A small plan is covered by the Starter Stack on its own.
    var smallKeys = ['tasters', 'tasters_tc', 'tasters3', 'tasters3_tc'];
    if (inp.newbie) {
      primary = { ride: 'starter_cycling', sportive: 'starter_cycling', marathon: 'starter_marathon', half: 'starter_marathon', run10k: 'starter_marathon', ultra: 'starter_marathon', training: 'starter_marathon', tri_short: 'starter_triathlon', tri_half: 'starter_triathlon', tri_full: 'starter_triathlon' }[inp.event] || 'starter';
      if (!recs[primary]) primary = 'starter';
      then = smallKeys.indexOf(sized) > -1 ? null : sized;
    }
    var chain = { long: ['starter'], tasters_tc: ['tasters'], tasters3: ['tasters5', 'tasters'], tasters3_tc: ['tasters3', 'tasters5_tc', 'tasters5', 'tasters_tc', 'tasters'], tasters5: ['pastilles', 'tasters'], tasters5_tc: ['tasters5', 'pastilles_tc', 'pastilles', 'tasters_tc', 'tasters'], pastilles_tc: ['pastilles'], raceweek_tc: ['raceweek'], fluids_core: ['fluids'], system: ['long'], raceweek: ['long'], rotation: ['pastilles'], starter_cycling: ['starter'], starter_marathon: ['starter'], starter_triathlon: ['starter'] };
    function resolve(key) { var tries = [key].concat(chain[key] || []).concat(['starter']); for (var i = 0; i < tries.length; i++) if (recs[tries[i]]) return tries[i]; return null; }
    primary = resolve(primary); if (then) then = resolve(then); if (then === primary) then = null;
    var addon = null;
    var kitHas = { starter: ['pouch'], starter_cycling: ['pouch'], starter_marathon: ['pouch'], starter_triathlon: ['pouch'], long: ['bottle', 'pouch'], raceweek: ['bottle', 'pouch'], raceweek_tc: ['bottle', 'pouch'], system: ['bottle', 'pouch'], fluids_rotation: ['bottle'] };
    var mainKey = then || primary;
    if (p.salty && ['tasters', 'tasters_tc', 'tasters3', 'tasters3_tc', 'tasters5', 'tasters5_tc', 'pastilles', 'pastilles_tc', 'rotation', 'starter', 'starter_marathon', 'starter_cycling', 'starter_triathlon'].indexOf(mainKey) > -1 && recs.electrolytes) addon = 'electrolytes';
    if (!addon) {
      var has = (kitHas[primary] || []).concat(kitHas[then] || []);
      var gear = inp.pref === 'drink' ? ['bottle', 'pouch'] : ['pouch', 'bottle'];
      if (inp.carry === 'pockets') gear = ['pouch'];
      for (var g = 0; g < gear.length; g++) if (has.indexOf(gear[g]) < 0 && recs[gear[g]]) { addon = gear[g]; break; }
    }
    return { primary: primary, then: then, addon: addon, note: note };
  }

  // Plan lines
  function lines(inp, p, xl) {
    var rows = [], ev = p.ev;
    var caff = inp.caffeine !== 'no';
    p.legs.forEach(function (l) {
      var d = l.d;
      if (l.name === 'Swim') { rows.push(['Swim', 'Nothing to take. Have 2 pastilles in the last 15 minutes before the start if there\'s a long wait.']); return; }
      if (!d.carbs) { rows.push([l.name, 'Under an hour, water is enough. Two pastilles 20 minutes before the start if you want fuel on board, nothing to carry.' + (p.salty ? ' You sweat salty, so put an Electrolyte Tablet in your bottle.' : '')]); return; }
      var bits = [];
      if (d.scoops) bits.push(plural(d.scoops, 'scoop') + ' of Power Fluids' + (inp.refill ? ' (' + (Math.round(d.scoopsPH * 10) / 10) + ' an hour, about ' + p.fluid + 'ml of fluid an hour)' : ' across your bottle' + (d.bottles > 1 ? 's' : '')));
      if (d.chews) bits.push(plural(d.chews, 'Energy Pastille') + ', one every ' + d.every + ' min');
      rows.push([l.name, fmtH(d.hours) + ' at ' + d.carbs + 'g an hour: ' + bits.join(' plus ') + '.']);
    });
    var startTxt = ev.sport === 'tri' ? 'Settle for 10 minutes on the bike, then start eating and stick to the clock.' : 'First pastille at ' + (ev.sport === 'ride' ? 15 : 20) + ' minutes, then stick to the clock.';
    if (p.target) {
      rows.push(['Start', startTxt + ' Set a repeating timer on your watch.']);
      if (ev.race && p.raceH >= 2 && caff && p.raceScoops > 0) rows.push(['Caffeine', (inp.refill || inp.carry === 'two') ? 'Make your second-half bottle Power Fluids Core (50mg caffeine a scoop).' : 'Mix your bottle with Power Fluids Core (50mg caffeine a scoop) and save most of it for the second half.']);
      if (ev.race && p.raceH >= 2.5 && xl) rows.push(['Back pocket', 'One Extra Life for the last third: 50g carbs, 100mg caffeine and 150mg sodium in one sachet. <a href="' + xl + '">Landing in November</a>']);
    }
    if (p.tabsPH && inp.carry !== 'pockets' && (ev.sport !== 'run' || p.salty)) rows.push(['Salt', 'About ' + p.sodium + 'mg sodium an hour. ' + plural(p.tabsPH, 'Electrolyte Tablet') + ' an hour in water covers the gap.']);
    else if (p.tabsPH && p.salty) rows.push(['Salt', 'You lose a lot of salt. Have an Electrolyte Tablet in 500ml of water before the start, and take water at every ' + (ev.race ? 'aid station' : 'stop') + '.']);
    if (inp.carry === 'pockets' && p.target) rows.push(['Fluid', 'No bottle, so drink about ' + p.fluid + 'ml an hour ' + (ev.race ? 'at aid stations' : 'on your route, so plan a loop past a tap or shop') + '.']);
    return rows.filter(function (r) { return r[1]; });
  }

  function blockLines(inp, p) {
    var rows = [], tw = p.thisWeek;
    if (p.ev.race && p.days !== null && p.days < 0) return [['Race', 'That date has passed. Pick your next one.']];
    if (tw.fuelled) rows.push(['This week', 'Long ' + ({ ride: 'ride', run: 'run', tri: 'session' }[p.ev.sport]) + ' of about ' + fmtH(tw.hours) + ': aim for ' + tw.rate + 'g an hour, ' + plural(tw.chews, 'pastille') + (tw.scoops ? ' and ' + plural(tw.scoops, 'scoop') : '') + '.']);
    else rows.push(['This week', 'Under ' + (p.ev.sport === 'ride' ? '90' : '75') + ' minutes you don\'t need to fuel. Practise taking 2 pastilles at 45 minutes anyway.']);
    if (p.ev.race && p.target > tw.rate) rows.push(['Build', 'Add about 5 to 10g an hour each long ' + (p.ev.sport === 'ride' ? 'ride' : 'run') + ' until you\'re taking ' + p.target + 'g, so race day is a rehearsal, not an experiment.']);
    rows.push([p.ev.race ? 'Your plan' : 'Every 6 weeks', (p.ev.race ? (p.weeks ? p.weeks + ' weeks' : 'Race week') + ': about ' : 'About ') + '' + Math.round(p.blockCarbs / 100) / 10 + 'kg of carbs, roughly ' + plural(p.blockChews, 'pastille') + (p.blockScoops ? ' and ' + plural(p.blockScoops, 'scoop') + ' of Power Fluids' : '') + '.']);
    return rows;
  }

  function fillRec(box, rec, label) {
    if (!box) return;
    if (!rec) { box.hidden = true; return; }
    box.hidden = false;
    var img = box.querySelector('img'); if (rec.image) img.src = rec.image; img.alt = rec.title;
    var lab = box.querySelector('[data-rec-label]'); if (lab) lab.textContent = label || '';
    box.querySelector('.ftp-rec__name').textContent = rec.title;
    box.querySelector('.ftp-rec__why').textContent = rec.why || '';
    var b = box.querySelector('.ftp-btn'); b.href = rec.url;
    b.querySelector('[data-out="price"]').textContent = rec.price;
    if (rec.variant) b.setAttribute('data-ftp-add', rec.variant); else b.removeAttribute('data-ftp-add');
  }

  function init(el) {
    var form = el.querySelector('form.ftp-form');
    var recs = {}; try { recs = JSON.parse(el.querySelector('[data-ftp-recs]').textContent); } catch (e) {}
    var xl = el.getAttribute('data-extra-life');
    var $ = function (s) { return el.querySelector(s); };
    var timeSel = $('[name=time]'), last = null, lastEvent = null;

    // Don't allow dates in the past in the picker
    var dateIn = $('[name=date]');
    if (dateIn) { var t = new Date(); dateIn.min = t.toISOString().slice(0, 10); dateIn.max = new Date(t.getTime() + 730 * 864e5).toISOString().slice(0, 10); }

    // Event picker: approved races first, then the editor's list of names
    var races = [], nameIn = $('[name=race_name]'), listEl = $('.ftp-racelist'), hintEl = $('[data-race-hint]'), active = -1, shown = [];
    try {
      var ri = JSON.parse(el.querySelector('[data-ftp-race-index]').textContent) || {};
      var today = new Date().toISOString().slice(0, 10);
      (Array.isArray(ri.approved) ? ri.approved : []).forEach(function (r) { if (r && r.slug && r.name && (!r.date || r.date >= today)) races.push(r); });
      (ri.names || []).forEach(function (n) { if (!races.some(function (r) { return r.name.toLowerCase() === String(n).toLowerCase(); })) races.push({ name: String(n) }); });
    } catch (e) {}
    el._races = races;
    function closeList() { if (listEl) { listEl.hidden = true; listEl.innerHTML = ''; } if (nameIn) nameIn.setAttribute('aria-expanded', 'false'); active = -1; shown = []; }
    function showHint(r) {
      if (!hintEl) return;
      if (r && r.slug) { hintEl.hidden = false; hintEl.textContent = r.course ? 'Race brief ready: your emails will cover the ' + r.name + ' course, aid stations and weather.' : 'Got it: ' + r.name + (r.date ? ', ' + fmtRaceDate(r.date) : '') + '.'; }
      else hintEl.hidden = true;
    }
    function pick(r) {
      el._pick = r && r.slug ? r : null;
      if (r) {
        nameIn.value = r.name;
        if (r.date && dateIn) dateIn.value = r.date;
        var evSel = form.querySelector('[name=event]');
        if (r.event_type && EVENTS[r.event_type] && evSel && evSel.value !== r.event_type) { evSel.value = r.event_type; lastEvent = null; }
      }
      showHint(el._pick); closeList(); render();
    }
    function drawList() {
      shown = matchRaces(nameIn.value, races, form.querySelector('[name=event]').value);
      if (!shown.length || (el._pick && nameIn.value === el._pick.name)) { closeList(); return; }
      listEl.innerHTML = shown.map(function (m, i) {
        var r = m.r, meta = [r.date ? fmtRaceDate(r.date) : '', r.location || ''].filter(Boolean).join(' · ');
        return '<li role="option" id="' + listEl.id + '-' + i + '" aria-selected="' + (i === active) + '" data-i="' + i + '"><span></span>' + (meta ? '<small></small>' : '') + '</li>';
      }).join('');
      shown.forEach(function (m, i) { var li = listEl.children[i]; li.querySelector('span').textContent = m.r.name; var sm = li.querySelector('small'); if (sm) sm.textContent = [m.r.date ? fmtRaceDate(m.r.date) : '', m.r.location || ''].filter(Boolean).join(' · '); });
      listEl.hidden = false; nameIn.setAttribute('aria-expanded', 'true');
    }
    // auto-resolve a clear single match when the field is left without choosing
    function autoResolve() {
      if (!nameIn || el._pick || !nameIn.value.trim()) return;
      var m = matchRaces(nameIn.value, races, form.querySelector('[name=event]').value).filter(function (x) { return x.r.slug; });
      if (m.length && ((m.length === 1 && m[0].s >= 0.7) || (m[0].s >= 0.85 && (m.length === 1 || m[0].s - m[1].s >= 0.1)))) pick(m[0].r);
    }
    if (nameIn && listEl) {
      nameIn.addEventListener('input', function () { if (el._pick && nameIn.value !== el._pick.name) { el._pick = null; showHint(null); } active = -1; drawList(); });
      nameIn.addEventListener('focus', drawList);
      nameIn.addEventListener('keydown', function (e) {
        if (listEl.hidden) return;
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); active = (active + (e.key === 'ArrowDown' ? 1 : -1) + shown.length) % shown.length; drawList(); nameIn.setAttribute('aria-activedescendant', listEl.id + '-' + active); }
        else if (e.key === 'Enter' && active >= 0) { e.preventDefault(); pick(shown[active].r); }
        else if (e.key === 'Escape') closeList();
      });
      listEl.addEventListener('mousedown', function (e) { var li = e.target.closest('li'); if (li) { e.preventDefault(); pick(shown[Number(li.getAttribute('data-i'))].r); } });
      nameIn.addEventListener('blur', function () { setTimeout(function () { closeList(); autoResolve(); }, 120); });
    }

    function fillTimes(evKey) {
      var ev = EVENTS[evKey]; if (!ev || evKey === lastEvent) return;
      lastEvent = evKey;
      var mid = Math.floor((ev.times.length - 1) / 2);
      timeSel.innerHTML = ev.times.map(function (o, i) { return '<option value="' + i + '"' + (i === mid ? ' selected' : '') + '>' + o[0] + '</option>'; }).join('');
      $('[data-time-label]').textContent = ev.timesLabel || 'Target finish time';
      el.querySelectorAll('[data-race-only]').forEach(function (n) { n.hidden = !ev.race; });
    }

    function read() {
      var fd = new FormData(form);
      return {
        event: fd.get('event'), time: Number(fd.get('time')) || 0, name: (fd.get('race_name') || '').trim(),
        date: fd.get('date') || '', weeks: fd.get('weeks'), longest: fd.get('longest'), sessions: fd.get('sessions'),
        sweat: fd.get('sweat'), cond: fd.get('cond'), pref: fd.get('pref'), carry: fd.get('carry'), refill: fd.get('refill') === 'yes',
        caffeine: fd.get('caffeine'), flavour: fd.get('flavour'), newbie: fd.get('newbie') === 'yes'
      };
    }

    function render() {
      fillTimes(form.querySelector('[name=event]').value);
      var inp = read();
      var weeksField = $('[data-weeks-field]'); if (weeksField) weeksField.hidden = !!inp.date || !EVENTS[inp.event].race;
      var p = plan(inp);
      $('[data-out="carbs"]').textContent = p.avgCarbs;
      $('[data-out="sodium"]').textContent = p.sodium;
      $('[data-out="fluid"]').textContent = p.fluid;
      var head = p.ev.race ? (inp.name || p.ev.label) + (p.days !== null && p.days >= 0 ? ' · ' + (p.days > 13 ? p.weeks + ' weeks to go' : plural(p.days, 'day') + ' to go') : '') : 'Your long sessions';
      $('[data-out="head"]').textContent = head;
      var sub = $('[data-sub-day]'); if (sub) sub.textContent = p.ev.race ? 'On the day' : 'Each long session';
      var rows = lines(inp, p, xl);
      $('[data-out="plan"]').innerHTML = rows.map(function (r) { return '<li><span>' + r[0] + '</span><div>' + r[1] + '</div></li>'; }).join('');
      var brows = blockLines(inp, p);
      $('[data-out="block"]').innerHTML = brows.map(function (r) { return '<li><span>' + r[0] + '</span><div>' + r[1] + '</div></li>'; }).join('');
      var b = basket(inp, p, recs);
      fillRec($('[data-out="rec"]'), recs[b.primary], b.then ? 'Start here' : 'What we\'d get you');
      fillRec($('[data-out="then"]'), b.then ? recs[b.then] : null, 'Then for the rest of your plan');
      fillRec($('[data-out="addon"]'), b.addon ? recs[b.addon] : null, 'Add');
      var noteEl = $('[data-out="note"]'); noteEl.textContent = b.note; noteEl.hidden = !b.note;
      var capH = $('[data-cap-head]'); if (capH) capH.textContent = p.ev.race && inp.date ? 'Get your race countdown' : (capH.getAttribute('data-default') || 'Email me my plan');
      last = { input: inp, plan: p, rows: rows, brows: brows, basket: b, recs: recs, pick: el._pick || null, races: el._races || [] };
    }
    form.addEventListener('input', render);
    form.addEventListener('change', render);
    form.addEventListener('submit', function (e) { e.preventDefault(); });
    render();

    // 3 Oct 2026: the result stays folded behind "See my fuel plan" until the first click; it keeps updating live after that.
    var resultEl = el.querySelector('.ftp-result'), teaser = el.querySelector('[data-ftp-teaser]'), body = el.querySelector('[data-ftp-body]');
    function reveal(scroll) {
      if (!el.classList.contains('is-open')) {
        el.classList.add('is-open');
        if (teaser) teaser.hidden = true;
        if (body) body.hidden = false;
        try { window.gtag && gtag('event', 'fuel_plan_viewed', { event_type: last && last.input.event, kit: last && last.basket.primary }); } catch (err) {}
      }
      if (scroll && resultEl) setTimeout(function () {
        var hdr = document.querySelector('.shopify-section-header');
        var off = (hdr && /sticky|fixed/.test(getComputedStyle(hdr).position) ? hdr.getBoundingClientRect().height : 0) + 12;
        window.scrollTo({ top: resultEl.getBoundingClientRect().top + window.pageYOffset - off, behavior: 'smooth' });
      }, 30);
    }
    el.querySelectorAll('[data-ftp-see]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); reveal(window.innerWidth <= 1000 || b.closest('form')); }); });
    if (!teaser || !body) el.classList.add('is-open'); // older section markup: nothing to fold

    var cap = el.querySelector('[data-ftp-plancap]');
    if (cap) cap.addEventListener('submit', function (e) { e.preventDefault(); send(cap, last); });
  }

  /* Email me my plan: subscribe (source "Fuel planner"), set race properties on the profile, and record a
     "Requested Fuel Plan" event. The race countdown flows in Klaviyo run off race_date. */
  function send(cap, last) {
    var msg = cap.querySelector('.ftp-msg'), input = cap.querySelector('input[type=email]');
    var email = input.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { msg.className = 'ftp-msg ftp-msg--err'; msg.textContent = 'Enter an email address like name@example.com.'; input.focus(); return; }
    if (!last) return;
    var i = last.input, p = last.plan, b = last.basket, recs = last.recs;
    if (p.ev.race && i.date) {
      var dd = Math.round((new Date(i.date + 'T12:00:00') - new Date()) / 864e5);
      if (isNaN(dd) || dd < 0 || dd > 730) { msg.className = 'ftp-msg ftp-msg--err'; msg.textContent = 'Check your race date. It needs to be in the next two years.'; var di = document.querySelector('[data-ftp-planner2] [name=date]'); if (di) di.focus(); return; }
    }
    var bike = p.legs.filter(function (l) { return l.name === 'Bike'; })[0], run = p.legs.filter(function (l) { return l.name === 'Run' || l.name === 'Ride'; })[0];
    var year = i.date ? i.date.slice(0, 4) : '';
    var props = {
      fuel_plan_sport: { run: 'Running', ride: 'Cycling', tri: 'Triathlon' }[p.ev.sport],
      fuel_plan_hours: p.raceH, fuel_plan_carbs_per_hour: p.avgCarbs, fuel_plan_sodium_per_hour: p.sodium, fuel_plan_fluid_per_hour: p.fluid,
      fuel_plan_preference: i.pref, fuel_plan_carry: i.carry, fuel_plan_sweat: i.sweat,
      race_event_type: i.event, race_event_label: p.ev.label, race_goal_time: p.timeLabel, race_hours: p.raceH,
      race_name: i.name || p.ev.label, race_slug: i.name ? slugify(i.name) + (year ? '-' + year : '') : '',
      race_carbs_per_hour: p.avgCarbs, race_total_pastilles: p.raceChews, race_total_scoops: p.raceScoops,
      race_pastille_every_min: run ? run.d.every : 0, race_bike_carbs_per_hour: bike ? bike.d.carbs : '', race_run_carbs_per_hour: run ? run.d.carbs : '',
      race_conditions: i.cond, race_caffeine: i.caffeine, race_flavour: i.flavour, race_refill: i.refill,
      plan_weeks: p.weeks, plan_longest_now_hours: p.L0, plan_sessions_per_week: Number(i.sessions) || 1,
      plan_block_carbs_g: p.blockCarbs, plan_block_pastilles: p.blockChews, plan_block_scoops: p.blockScoops,
      plan_this_week_rate: p.thisWeek.rate, plan_target_rate: p.target, new_to_ftp: i.newbie,
      fuel_plan_requested_at: new Date().toISOString().slice(0, 10)
    };
    // An approved race picked (or clearly matched) from the list uses its canonical slug and gets its brief straight away
    var pk = last.pick;
    if (!pk && i.name) { var mm = matchRaces(i.name, last.races || [], i.event).filter(function (x) { return x.r.slug; }); if (mm.length && ((mm.length === 1 && mm[0].s >= 0.7) || (mm[0].s >= 0.85 && (mm.length === 1 || mm[0].s - mm[1].s >= 0.1)))) pk = mm[0].r; }
    if (pk && pk.date && i.date && pk.date !== i.date) pk = null; // a different edition of the race
    if (pk) { props.race_name = pk.name; props.race_slug = pk.slug; }
    if (p.ev.race && i.date) {
      props.race_date = i.date;
      if (pk && pk.course) {
        props.race_brief_ready = true; props.race_brief_slug = pk.slug;
        props.race_brief_course = pk.course || ''; props.race_brief_aid = pk.aid || ''; props.race_brief_watch = pk.watch || '';
        props.race_brief_weather = pk.weather || ''; props.race_brief_source = pk.source || '';
      } else {
        // a new race: the daily brief task attaches the brief once Rob approves it for this race_slug
        props.race_brief_ready = false; props.race_brief_slug = '';
      }
    } else {
      // no dated race: keep any existing race countdown untouched
      Object.keys(props).forEach(function (k) { if (k.indexOf('race_') === 0) delete props[k]; });
    }
    var eventProps = Object.assign({}, props, {
      plan_lines: last.rows.map(function (r) { return r[0] + ': ' + r[1].replace(/<[^>]+>/g, ''); }),
      block_lines: last.brows.map(function (r) { return r[0] + ': ' + r[1]; }),
      total_carbs: Math.round(p.avgCarbs * p.raceH),
      recommended_kit: recs[b.primary] ? recs[b.primary].title : '', recommended_url: recs[b.primary] ? new URL(recs[b.primary].url, location.origin).href : '',
      recommended_then: b.then && recs[b.then] ? recs[b.then].title : '', recommended_addon: b.addon && recs[b.addon] ? recs[b.addon].title : '',
      basket_note: b.note
    });
    var company = cap.getAttribute('data-company'), list = cap.getAttribute('data-list');
    var headers = { 'Content-Type': 'application/json', revision: '2024-10-15' };
    var base = 'https://a.klaviyo.com/client/', q = '?company_id=' + encodeURIComponent(company);
    var btn = cap.querySelector('button'); btn.setAttribute('aria-busy', 'true'); btn.disabled = true;
    function post(path, body) { return fetch(base + path + q, { method: 'POST', headers: headers, body: JSON.stringify(body) }).then(function (r) { if (!r.ok && r.status !== 202) throw new Error(path + ' ' + r.status); return r; }); }
    var subBody = { data: { type: 'subscription', attributes: { custom_source: 'Fuel planner', profile: { data: { type: 'profile', attributes: { email: email, properties: props } } } }, relationships: { list: { data: { type: 'list', id: list } } } } };
    post('subscriptions/', subBody)
      .catch(function () { delete subBody.data.attributes.profile.data.attributes.properties; return post('subscriptions/', subBody); }) // 3 Oct 2026: retry without properties if Klaviyo rejects them; the profiles/ call below still sets them
      .then(function () { return post('profiles/', { data: { type: 'profile', attributes: { email: email, properties: props } } }).catch(function () {}); })
      .then(function () { return post('events/', { data: { type: 'event', attributes: { properties: eventProps, metric: { data: { type: 'metric', attributes: { name: 'Requested Fuel Plan' } } }, profile: { data: { type: 'profile', attributes: { email: email } } } } } }); })
      .then(function () {
        try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email }); } catch (err) {}
        // 6 Oct 2026: tell the ad platforms a plan was requested (Lead), so a Meta or Google campaign can optimise to it.
        try { var leadId = 'fp-' + Date.now(); if (window.fbq) fbq('track', 'Lead', { content_name: 'fuel_plan', content_category: p.ev.label, value: 0, currency: 'GBP' }, { eventID: leadId }); } catch (err) {}
        try { window.gtag && gtag('event', 'generate_lead', { event_type: i.event, race_dated: !!props.race_date }); } catch (err) {}
        try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish('fuel_plan_requested', { event_type: i.event, sport: props.fuel_plan_sport, carbs_per_hour: p.avgCarbs, race_dated: !!props.race_date }); } catch (err) {}
        msg.className = 'ftp-msg ftp-msg--ok';
        msg.textContent = props.race_date ? 'Done. Your plan is on its way, and we\'ll be in touch as ' + (i.name || 'race day') + ' gets closer.' : 'Done. Your ' + p.avgCarbs + 'g/hr plan is on its way to ' + email + '.';
        cap.classList.add('is-sent');
      })
      .catch(function () { msg.className = 'ftp-msg ftp-msg--err'; msg.textContent = 'That didn’t go through. Check your connection and try again.'; })
      .finally(function () { btn.removeAttribute('aria-busy'); btn.disabled = false; });
  }

  /* 6 Oct 2026: Meta pixel for the planner only. The store's Meta pixel runs inside Shopify's Facebook channel sandbox, which only
     forwards standard shop events, so a plan request was invisible to Meta. This loads fbevents.js on pages that carry the planner,
     initialises the same pixel with automatic events OFF and no PageView (the channel pixel already sends those), and send() above
     fires one Lead event when "Send my strategy" succeeds. */
  function loadPixel() {
    try {
      if (window.fbq || window.__ftpPixelLoaded) return;
      window.__ftpPixelLoaded = true;
      (function (w, d) { var n = w.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); }; if (!w._fbq) w._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; var s = d.createElement('script'); s.async = !0; s.src = 'https://connect.facebook.net/en_US/fbevents.js'; var f = d.getElementsByTagName('script')[0]; f.parentNode.insertBefore(s, f); })(window, document);
      fbq('set', 'autoConfig', false, '742653428486227');
      fbq('init', '742653428486227');
    } catch (err) {}
  }
  function boot(scope) { var els = (scope || document).querySelectorAll('[data-ftp-planner2]'); if (els.length) loadPixel(); els.forEach(function (el) { if (!el._ftp2) { el._ftp2 = 1; init(el); } }); }
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  }
  if (typeof module !== 'undefined') module.exports = { plan: plan, basket: basket, lines: lines, blockLines: blockLines, EVENTS: EVENTS };
})();
